export default __webpack_public_path__ + "static/media/graph_black.a90897b1.svg";